// @flow
'use strict';

import Totais from './totais/index';

export default Totais;
